import ClockAlertSvg from '@assets/images/svg/clock-alert.svg';
import React from 'react';
import { View } from 'react-native';

export interface ClockAlertIconProps {
    size?: number;
    color?: string;
}

export function ClockAlertIcon({ size = 80, color = '#333333' }: ClockAlertIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ClockAlertSvg width={size} height={size} color={color} />
        </View>
    );
}
